<template>
  <component :is="activeComponent" />
</template>

<script setup>
import { computed } from 'vue'
import ConsentWebBanner from './ConsentWebBanner.vue'
import ConsentBottomSheet from './ConsentBottomSheet.vue'

const isNative = computed(() => {
  return window.Capacitor && window.Capacitor.isNativePlatform()
})

const activeComponent = computed(() => {
  return isNative.value ? ConsentBottomSheet : ConsentWebBanner
})
</script>
